export const ORDER_STATUS = {
  NEW: "NEW",
  PENDING: "PENDING",
  PAID: "PAID",
  FREE: "FREE",
  PART_PAID: "PART_PAID",
  EXPIRED: "EXPIRED",
  FAILED: "FAILED",
}
